// True only when FastF1 marked the lap valid for performance comparison
// (excludes pit in/out, deleted laps, and laps under SC / VSC / yellow / red).
// Strict boolean check so legacy NULL rows fall through to "not clean".
export const isCleanLap = (lap) => lap?.is_accurate === true;

export const isQualifyingSession = (session) => session === 'Q' || session === 'SQ';

// Fastest valid lap time across the supplied laps, or null if none.
export const sessionFastestSeconds = (laps) => {
  let best = Infinity;
  for (const l of laps) {
    const t = Number(l?.lap_time_seconds);
    if (Number.isFinite(t) && t > 0 && t < best) best = t;
  }
  return Number.isFinite(best) ? best : null;
};

// 107% rule: keep laps within 7% of the session's fastest. Cleans up the
// qualifying y-axis by dropping out/in laps and aborted runs.
export const isWithin107 = (lap, fastest) => {
  if (fastest == null) return true;
  const t = Number(lap?.lap_time_seconds);
  return Number.isFinite(t) && t <= fastest * 1.07;
};
